//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../no/SelectViewList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Date",1,0],[0,"MatchPMIProperties",1,0],[0,"OutputFileName",1,0],[0,"OverwriteOutputFileOption",1,0],[0,"ProjectName",1,0],[1,"SelectedViews",0,"SelectViewList",0],[0,"TemplateSize",1,0],[0,"UserName",1,0],[0,"ViewSelection",1,0]],[[[],"Publish",{R_:{result:''}},0,0],[[],"GetWorkTemplateFilename",{R_:{templateFilename:''}},0,0],[["templateFilename"],"SetWorkTemplateFile",{},1,0],[["numModelViews","modelViews"],"GetSelectedModelViewsList",{},0,0],[["viewsList"],"SetModelViewsToSelection",{},1,0]],[]];
SPLM.Drawings.PDFPublisherBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.PDFPublisherBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.PDFPublisherBuilder.ViewSelectionType = Object.freeze({
    "SelectedViews" : "SelectedViews", "AllUserDefinedViews" : "AllUserDefinedViews", "AllViews" : "AllViews"});

SPLM.Drawings.PDFPublisherBuilder.PublishResult = Object.freeze({
    "Success" : "Success", "SuccessWithInconsistency" : "SuccessWithInconsistency", "SuccessWithError" : "SuccessWithError", "Fail" : "Fail"});

SPLM.Drawings.PDFPublisherBuilder.TemplateType = Object.freeze({
    "Undefined" : "Undefined", "MetricSizeA4Landscape" : "MetricSizeA4Landscape", "MetricSizeA4Portrait" : "MetricSizeA4Portrait", "InchesSizeALandscape" : "InchesSizeALandscape", "InchesSizeAPortrait" : "InchesSizeAPortrait"});

export default SPLM;